import React from "react";
import { Loader2 } from "lucide-react";

export const Field = ({ label, hint, children, className = "" }) => (
  <label className={`block ${className}`}>
    <span className="block text-[11px] font-bold uppercase tracking-[0.14em] text-forest/70 mb-1.5">{label}</span>
    {children}
    {hint && <span className="block text-[11px] text-mutedgreen mt-1">{hint}</span>}
  </label>
);

const inputCls = "w-full bg-white border border-forest/15 rounded-xl px-3.5 py-2.5 text-sm text-ink placeholder:text-mutedgreen/60 focus:outline-none focus:border-gold focus:ring-2 focus:ring-gold/20 transition-colors disabled:opacity-60";

export const Input = (props) => <input {...props} className={`${inputCls} ${props.className || ""}`} />;
export const Textarea = (props) => <textarea rows={3} {...props} className={`${inputCls} ${props.className || ""}`} />;
export const Select = ({ children, ...props }) => <select {...props} className={`${inputCls} ${props.className || ""}`}>{children}</select>;

export const Toggle = ({ checked, onChange, label, testId }) => (
  <button type="button" role="switch" aria-checked={checked} data-testid={testId} onClick={() => onChange(!checked)} className="flex items-center gap-3 group">
    <span className={`relative w-11 h-6 rounded-full transition-colors ${checked ? "bg-forest" : "bg-forest/20"}`}>
      <span className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full bg-white shadow transition-transform ${checked ? "translate-x-5" : ""}`} />
    </span>
    {label && <span className="text-sm text-forest">{label}</span>}
  </button>
);

export const Btn = ({ children, variant = "primary", busy = false, className = "", ...props }) => {
  const styles = {
    primary: "bg-forest text-cream hover:bg-gold",
    gold: "bg-gold text-white hover:bg-goldlight",
    ghost: "bg-transparent text-forest border border-forest/20 hover:bg-forest/5",
    danger: "bg-transparent text-red-700 border border-red-200 hover:bg-red-50",
  };
  return (
    <button {...props} disabled={busy || props.disabled} className={`inline-flex items-center justify-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] px-5 py-2.5 rounded-full transition-colors disabled:opacity-60 ${styles[variant]} ${className}`}>
      {busy && <Loader2 size={13} className="animate-spin" />}
      {children}
    </button>
  );
};

export const Card = ({ children, className = "", ...props }) => (
  <div {...props} className={`bg-white border border-forest/10 rounded-2xl ${className}`}>{children}</div>
);

export const PageTitle = ({ title, sub, action }) => (
  <div className="flex flex-wrap items-end justify-between gap-4 mb-8">
    <div>
      <h1 className="font-serif text-3xl text-forest">{title}</h1>
      {sub && <p className="text-sm text-mutedgreen mt-1">{sub}</p>}
    </div>
    {action}
  </div>
);

export const Empty = ({ text }) => <p className="text-sm text-mutedgreen text-center py-12">{text}</p>;

export const discountPct = (mrp, price) => (mrp && mrp > price ? Math.round(((mrp - price) / mrp) * 100) : 0);
